import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import NoticeHelper from 'helpers/notice'
import * as ApiRouter from 'constants/apiRouting'
import { SHOW_NOTICE } from '../notice'
import {
  FETCH_SITE_LIST,
  SUCCESS_SITE_LIST,
  FAILURE_SITE_LIST,
  FETCH_LOCUS_LIST,
  SUCCESS_LOCUS_LIST,
  FAILURE_LOCUS_LIST,
  FETCH_FILTERS,
  SUCCESS_FILTERS,
  FAILURE_FILTERS,
  FETCH_DATA,
  SUCCESS_DATA,
  FAILURE_DATA,
  SET_SITE_LIST_LOADER,
  SET_LOCUS_LIST_LOADER,
  SET_SUMMARY_LOADER,
  SET_TABLE_LOADER,
  FETCH_CRITERIA_LIST,
  SUCCESS_CRITERIA_LIST,
  FAILURE_CRITERIA_LIST,
  FETCH_INDICATORS_LIST,
  SUCCESS_INDICATORS_LIST,
  FAILURE_INDICATORS_LIST,
  FETCH_POLICY_EDITOR_DATA,
  SUCCESS_POLICY_EDITOR_DATA,
  FAILURE_POLICY_EDITOR_DATA,
  UPDATE_NOTIFICATION_SUBSCRIBERS,
  UPDATE_NOTIFICATION_SUBSCRIBERS_SUCCESS,
  UPDATE_NOTIFICATION_SUBSCRIBERS_FAILURE,
  FETCH_REGION_LIST,
  FETCH_REGION_LIST_SUCCESS,
  FETCH_REGION_LIST_FAILURE,
  FETCH_SITE_GROUPS_LIST,
  FETCH_SITE_GROUPS_LIST_SUCCESS,
  FETCH_SITE_GROUPS_LIST_FAILURE,
  FETCH_SITE_TYPES,
  FETCH_SUCCESS_SITE_TYPES,
  FETCH_FAILURE_SITE_TYPES,
  FETCH_LOCUS_GROUPS,
  FETCH_SUCCESS_LOCUS_GROUPS,
  FETCH_FAILURE_LOCUS_GROUPS,
} from './reducer'

function* fetchSiteList(action) {
  try {
    yield put({ type: SET_SITE_LIST_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${
        ApiRouter.MONITORING_ALERTS_SITE_LIST
      }${UrlHelper.getPsfsQuery(action.payload)}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_SITE_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_SITE_LIST })
    }

    yield put({ type: SET_SITE_LIST_LOADER, payload: false })
  } catch (error) {
    console.log('MONITORS AND ALERTS FAILED ', error)
  }
}

function* fetchLocusList(action) {
  try {
    yield put({ type: SET_LOCUS_LIST_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${
        ApiRouter.MONITORING_ALERTS_LOCUS_LIST
      }${UrlHelper.getPsfsQuery(action.payload)}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_LOCUS_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_LOCUS_LIST })
    }

    yield put({ type: SET_LOCUS_LIST_LOADER, payload: false })
  } catch (error) {
    console.log('MONITORS AND ALERTS FAILED ', error)
  }
}

function* fetchFilters(action) {
  try {
    yield put({ type: SET_SUMMARY_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        ApiRouter.MONITORING_ALERTS_POLICIES,
        action.payload,
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_FILTERS,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_FILTERS })
    }

    yield put({ type: SET_SUMMARY_LOADER, payload: false })
  } catch (error) {
    console.log('MONITORS AND ALERTS FAILED ', error)
  }
}

function* fetchData({ payload }) {
  try {
    yield put({ type: SET_TABLE_LOADER, payload: true })

    const { params } = payload
    let response = null

    if (!params.hasOwnProperty('clearData')) {
      response = yield call(fetchFromAPI, {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.createQuery(
          `${
            ApiRouter.MONITORING_ALERTS_INDICATORS_TABLE
          }${UrlHelper.getPsfsQuery(payload)}`,
          params,
        ),
      })
    }

    if (response && !response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_DATA,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_DATA })
    }

    yield put({ type: SET_TABLE_LOADER, payload: false })
  } catch (error) {
    console.log('MONITORS AND ALERTS FAILED ', error)
  }
}

function* fetchCriteriaList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        ApiRouter.MONITORING_ALERTS_POLICIES,
        action.payload,
      ),
    })

    if (response && !response.error) {
      yield put({ type: SUCCESS_CRITERIA_LIST, payload: response })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }

      yield put({ type: FAILURE_CRITERIA_LIST, error: response.error })
    }
  } catch (error) {
    console.log('CRITERIA LIST FETCH FAILURE ', error)
  }
}

function* fetchIndicatorList() {
  try {
    const response = [
      { id: 'indicator_criticality_level_alert', name: 'Alert' },
      { id: 'indicator_criticality_level_warning', name: 'Warning' },
      { id: 'indicator_criticality_level_normal', name: 'Normal' },
      { id: 'indicator_criticality_level_no_status', name: 'No status' },
    ]

    if (response && !response.error) {
      yield put({ type: SUCCESS_INDICATORS_LIST, payload: response })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }

      yield put({ type: FAILURE_INDICATORS_LIST, error: response.error })
    }
  } catch (error) {
    console.log('INDICATOR LIST FETCH FAILURE ', error)
  }
}

function* fetchPolicyEditorList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        ApiRouter.MONITORING_ALERTS_POLICY_EDITOR_LIST,
        action.payload,
      ),
    })

    if (response && !response.error) {
      yield put({ type: SUCCESS_POLICY_EDITOR_DATA, payload: response })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }

      yield put({ type: FAILURE_POLICY_EDITOR_DATA, error: response.error })
    }
  } catch (error) {
    console.log('POLICY EDITOR FETCH FAILURE ', error)
  }
}

function* updateNotificationSubscribers({ payload }) {
  const { data, users, successMessage } = payload

  try {
    const response = yield call(fetchFromAPI, {
      method: 'PUT',
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRouter.MONITORING_ALERTS_POLICY_EDITOR_LIST,
      data,
    })

    if (response && !response.error) {
      // eslint-disable-next-line no-unused-vars
      const { policy, users, ...rest } = data

      yield put({ type: UPDATE_NOTIFICATION_SUBSCRIBERS_SUCCESS })
      yield put({ type: FETCH_POLICY_EDITOR_DATA, payload: rest })
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(successMessage),
      })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }

      yield put({
        type: UPDATE_NOTIFICATION_SUBSCRIBERS_FAILURE,
        payload: users,
        error: response.error,
      })
    }
  } catch (error) {
    console.log('SET ACTIVE USERS BY NOTIFICATIONS SET FAILURE ', error)
  }
}

function* fetchRegionList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.REGION_LIST}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: FETCH_REGION_LIST_SUCCESS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_REGION_LIST_FAILURE })
    }
  } catch (error) {
    console.log('FETCH REGION LIST FAILURE ', error)
  }
}

function* fetchSiteGroupsList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.SITE_GROUPS_LIST}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: FETCH_SITE_GROUPS_LIST_SUCCESS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_SITE_GROUPS_LIST_FAILURE })
    }
  } catch (error) {
    console.log('FETCH SITEGROUPS LIST FAILURE ', error)
  }
}

function* fetchSiteTypes(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        ApiRouter.ACTIVE_SITE_TYPE_LIST,
        action.payload,
      ),
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({ type: FETCH_SUCCESS_SITE_TYPES, payload: response })
    } else {
      yield put({ type: FETCH_FAILURE_SITE_TYPES })
    }
  } catch (error) {
    console.log('FETCH SITE TYPES FAILURE ', error)
  }
}

function* fetchLocusGroups(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_GROUPS}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: FETCH_SUCCESS_LOCUS_GROUPS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_FAILURE_LOCUS_GROUPS })
    }
  } catch (error) {
    console.log('FETTCH LOCUS GROUPS FAILURE ', error)
  }
}

function* monitorsAndAlerts() {
  yield takeLatest(FETCH_SITE_LIST, fetchSiteList)
  yield takeLatest(FETCH_LOCUS_LIST, fetchLocusList)
  yield takeLatest(FETCH_FILTERS, fetchFilters)
  yield takeLatest(FETCH_DATA, fetchData)
  yield takeLatest(FETCH_CRITERIA_LIST, fetchCriteriaList)
  yield takeLatest(FETCH_INDICATORS_LIST, fetchIndicatorList)
  yield takeLatest(FETCH_POLICY_EDITOR_DATA, fetchPolicyEditorList)
  yield takeLatest(
    UPDATE_NOTIFICATION_SUBSCRIBERS,
    updateNotificationSubscribers,
  )
  yield takeLatest(FETCH_REGION_LIST, fetchRegionList)
  yield takeLatest(FETCH_SITE_GROUPS_LIST, fetchSiteGroupsList)
  yield takeLatest(FETCH_SITE_TYPES, fetchSiteTypes)
  yield takeLatest(FETCH_LOCUS_GROUPS, fetchLocusGroups)
}

export default monitorsAndAlerts
